module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("List of Plates")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Reille commanded the II Corps. He wrote only a brief description of the battle and seems to have used it primarily to deflect blame for the failure around Hougoumont onto his subordinates.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Trefcon served as chief of staff to General Bachelu. He gives a rather uncontroversial account of the battle but is notable for having abandoned the army after the battle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Napoleon’s brother Jérôme was a divisional commander in the II Corps and was primarily responsible for the French action around Hougoumont. He appears to have abandoned his division sometime during the battle to join the emperor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Foy commanded a division in the II Corps. He made little contribution to the action around Hougoumont, but his description of his attack on the British ridge is interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Tromelin commanded a brigade in the VI Corps. His brief account describes the fighting against the Prussians on the French right flank.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Kellerman was an unenthusiastic supporter of Napoleon but accepted the command of the 3rd Cavalry Corps. He gives us some interesting detail on the French great cavalry attacks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Delort commanded a cuirassier division at Waterloo and gives an interesting account of the battle in general and the cavalry charges in detail.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Ordener inherited the command of a cuirassier brigade early in the battle after its original commander was wounded. His account concentrates on the great cavalry charges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Pelet commanded the 2nd Regiment of Chasseurs à Pied of the Imperial Guard. He gives a long and detailed account of the fighting against the Prussians in Planchenoit.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("Guyot commanded the heavy cavalry division of the Imperial Guard. He describes the actions of the division during the battle before he was wounded.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("De Brack served as a captain in the lancers of the Imperial Guard. He gives some interesting detail of the attacks against the Allied squares.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("This famous painting of the battle shows the fighting around Hougoumont. French accounts prove that far fewer troops were committed to the fighting here than is generally portrayed in Allied histories.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("This rather romanticised print shows Ney leading the great French cavalry attacks against a British square. The accounts of these charges are some of the most detailed of the French participants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("This sketch was drawn by Captain de Brack to show the futile charge of the carabiniers which is described by Kellerman in his account of the battle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentpaa"
  }, [_vm._v("This near contemporary map gives a good feel for the topography of the battlefield before it was changed by the construction of the Lion Mound.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f006baa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_List.vue
// module id = 69
// module chunks = 0